"use client"

import { Component } from "react"
import { Mobile, Notebook, PC, Tablet } from "../../ReactiveMode"

class WorshipInformation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      regularWorships: [
        {
          id: 1,
          name: "",
          time: "오전 09:30",
          location: "본당",
          badge: "주일 1부",
        },
        {
          id: 2,
          name: "",
          time: "오전 11:30",
          location: "본당",
          badge: "주일 2부",
        },
        {
          id: 3,
          name: "",
          time: "오후 02:30",
          location: "본당",
          badge: "주일 오후",
        },
        {
          id: 4,
          name: "",
          time: "오후 07:30",
          location: "본당",
          badge: "수요예배",
          special: true,
        },
        {
          id: 5,
          name: "",
          time: "오후 10:00",
          location: "본당",
          badge: "금요기도회",
          special: true,
        },
        {
          id: 6,
          name: "",
          time: "평일(화~금) 새벽 05:00 / 주일 새벽 06:00",
          location: "평일 기도실 / 주일 본당",
          badge: "새벽기도회",
          special: true,
        },
      ],
      churchSchools: [
        {
          id: 1,
          name: "",
          time: "오전 11:30",
          location: "본당 4층 영아부실",
          badge: "영아부",
        },
        {
          id: 2,
          name: "",
          time: "오전 11:30",
          location: "본당 1층 유치부실",
          badge: "유치부",
        },
        {
          id: 3,
          name: "",
          time: "오전 11:30",
          location: "교육관 2층 유초등부실",
          badge: "유초등부",
        },
        {
          id: 4,
          name: "",
          time: "오전 11:30",
          location: "교육관 4층 청소년부실",
          badge: "청소년부",
        },
      ],
    }
  }

  renderWorshipMobileTable = (worships) => {
    return (
        <table className="worship-table">
          <thead className="table-header">
          <tr>
            <th>예배명</th>
            <th>시간</th>
            <th>장소</th>
          </tr>
          </thead>
          <tbody className="table-body">
          {worships.map((worship) => (
              <tr key={worship.id}>
                <td className="worship-name">
                  <span className={`worship-badge ${worship.special ? "special" : ""}`}>{worship.badge}</span>
                  <br />
                  {worship.name}
                </td>
                <td className="worship-time">{worship.time}</td>
                <td className="worship-location">
                  <i className="fas fa-map-marker-alt location-icon"></i>
                  {worship.location}
                </td>
              </tr>
          ))}
          </tbody>
        </table>
    )
  }

  renderWorshipTable = (worships) => {
    return (
        <table className="worship-table">
          <thead className="table-header">
          <tr>
            <th>예배명</th>
            <th>시간</th>
            <th>장소</th>
          </tr>
          </thead>
          <tbody className="table-body">
          {worships.map((worship) => (
              <tr key={worship.id}>
                <td className="worship-name">
                  <span className={`worship-badge ${worship.special ? "special" : ""}`}>{worship.badge}</span>
                  {worship.name}
                </td>
                <td className="worship-time">{worship.time}</td>
                <td className="worship-location">
                  <i className="fas fa-map-marker-alt location-icon"></i>
                  {worship.location}
                </td>
              </tr>
          ))}
          </tbody>
        </table>
    )
  }

  render() {
    const { regularWorships, churchSchools } = this.state

    return (
        <section className="pf-page">
          <PC>
            <section className="worship-content">
              <div className="background">
                <div className="layout">
                  <div className="worship-schedule-section">
                    {/* 예배 안내 테이블 */}
                    <div className="worship-section-wrapper">
                      <h3 className="section-header">예배 안내</h3>
                      {this.renderWorshipTable(regularWorships)}
                    </div>

                    {/* 교회학교 주일예배 */}
                    <div className="church-school-section">
                      <h3 className="school-title">교회학교 주일예배</h3>
                      {this.renderWorshipTable(churchSchools)}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </PC>

          <Notebook>
            <section className="worship-content">
              <div className="background">
                <div className="layout">
                  <div className="worship-schedule-section">
                    <h1 className="section-title">예배 안내</h1>

                    <div className="worship-section-wrapper">
                      <h3 className="section-header">예배 안내</h3>
                      {this.renderWorshipTable(regularWorships)}
                    </div>

                    <div className="church-school-section">
                      <h3 className="school-title">교회학교 주일예배</h3>
                      {this.renderWorshipTable(churchSchools)}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Notebook>

          <Tablet>
            <section className="worship-content">
              <div className="background">
                <div className="layout">
                  <div className="worship-schedule-section">
                    <h1 className="section-title">예배 안내</h1>

                    <div className="worship-section-wrapper">
                      <h3 className="section-header">예배 안내</h3>
                      {this.renderWorshipTable(regularWorships)}
                    </div>

                    <div className="church-school-section">
                      <h3 className="school-title">교회학교 주일예배</h3>
                      {this.renderWorshipTable(churchSchools)}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Tablet>

          <Mobile>
            <section className="worship-content">
              <div className="background">
                <div className="layout">
                  <div className="worship-schedule-section">
                    <h1 className="section-title">예배 안내</h1>

                    <div className="worship-section-wrapper">
                      <h3 className="section-header">예배 안내</h3>
                      {this.renderWorshipMobileTable(regularWorships)}
                    </div>

                    <div className="church-school-section">
                      <h3 className="school-title">교회학교 주일예배</h3>
                      {this.renderWorshipMobileTable(churchSchools)}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Mobile>
        </section>
    )
  }
}

export default WorshipInformation
